export const modeRequest = {
  TRANSPOR: 1, // ТС
  PERMIT: 2, // Пропуск
};
